import React from 'react';
import '../style/button.css'

const  Button = (props) => {
    const {disabled, title} = props;
    return (
        <div className={props.wrapper}>
            <button
                type={props.btnType}
                className={props.btnStyle}
                onClick={props.clickHandler}
                disabled={disabled}
                title={title}
            >
                {props.label}
                <svg className={props.customArrowStyle?props.customArrowStyle:"btn-arrow"}
                     xmlns="http://www.w3.org/2000/svg"
                     viewBox="0 0 9.6 16">
                    <g id="Layer_2" data-name="Layer 2">
                        <g id="Layer_1-2" data-name="Layer 1">
                            <path
                                d="M9.6,8.08a1.63,1.63,0,0,1-.48,1.16L2.81,15.53A1.63,1.63,0,0,1,.52,13.21L5.68,8.07.47,2.78A1.63,1.63,0,1,1,2.78.49L9.13,6.94A1.63,1.63,0,0,1,9.6,8.08Z"/>
                        </g>
                    </g>
                </svg>
            </button>
        </div>

    )
};

export default Button;